<template>
    <div class="alert">
        <span @click="open">{{total}}</span>
        <button type="button" @click="open">
            <i class="fal fa-bell"/>
        </button>
        <section v-if="status" class="list" @mouseleave="close">
            <ui-overlay-load v-if="remove"/>
            <h4>Notificações</h4>
            <div class="items scroll-color">
                <ul>
                    <li v-for="item in notifications" :key="item.id" :ref="'item-'+item.id" >
                        <div class="text" @click="linkUrl(item.type, item.item_id)">{{item.title}}</div>
                        <div class="control">
                            <button type="button" @click="destroy(item.id)">
                                <i class="fal fa-times"/>
                            </button>
                        </div>
                    </li>
                </ul>
                <div v-if="!total" class="no-results">
                    <span>Nenhuma notificação encontrada.</span>
                </div>
            </div>
            <div v-if="total" class="clear-all">
                <button type="button" @click="clear">Limpar</button>
            </div>
        </section>
    </div>
</template>

<script>
    import { notifications } from '@/services/axios'
    import { uiOverlayLoad } from '@/components/ui'
    import helpers from '@/mixins/helpers'
	export default {
        name: 'ui-alerts',
        components: { uiOverlayLoad },
        mixins: [ helpers ],
        data(){
            return {    
                total: 0,
                notifications: [],
                status: false,
                remove: false,
            }
        },
        created(){ 
            this.get()

            this.$root.$on('notifications', () => {
                this.close()
            })
        },
        beforeDestroy() {
            this.$root.$off('notifications')
        },
        methods:{
            open(){
                this.status = !this.status
                this.$root.$emit('fast-menu')
            },
            close(){
                this.status = false
            },
            get(){
                notifications.noRead().then( response => {
                    this.total          = response.data.length
                    this.notifications  = response.data
                })
            },
            destroy(id){
                this.remove = true
                notifications.destroy(id).then( () => {
                    this.get()
                    this.remove = false
                })
            },
            clear(){
                this.remove = true
                notifications.markAll().then( () => {
                    this.get()
                    this.remove = false
                })
            },
            linkUrl(type, id){
                switch (type) {
                    case 'team':
                        this.oldPanelLinkButton(`perfil/grupo`)
                        break;
                    case 'award':
                        this.oldPanelLinkButton('clube/premios/listar')
                        break;
                    case 'user':
                        this.oldPanelLinkButton('perfil')
                        break;
                    case 'manager':
                        this.oldPanelLinkButton(`perfil/${id}`)
                        break;
                    case 'supervisor':
                        this.oldPanelLinkButton(`perfil/${id}`)
                        break;
                    case 'broker':
                        this.oldPanelLinkButton(`perfil/${id}`)
                        break;
                    case 'product':
                        this.oldPanelLinkButton(`empreendimentos/${id}/visualizar`)
                        break;
                    case 'product-update':
                        this.oldPanelLinkButton(`empreendimentos/listar?updated`)
                        break;
                    case 'news':
                        this.oldPanelLinkButton(`noticia/${id}`)
                        break;
                    case 'customer':
                        this.oldPanelLinkButton(`vendas/clientes/${id}`)
                        break;
                    case 'deal':
                        this.oldPanelLinkButton(`vendas/negocios/${id}`)
                        break;
                    case 'agenda':
                        this.oldPanelLinkButton(`eventos/${id}`)
                        break;
                    case 'redemption':
                        this.oldPanelLinkButton(`perfil/resgates`)
                        break;
                    case 'balance':
                        this.oldPanelLinkButton(`perfil/${id}`)
                        break;
                    case 'reserve':
                        this.$router.push('/vendas/reservas/lista')
                        break;
                    case 'funnel':
                        this.oldPanelLinkButton(`vendas/negocios/funil`)
                        break;
                    case 'task':
                        this.oldPanelLinkButton(`vendas/clientes/tarefas`)
                        break;
                    case 'leads':
                        this.oldPanelLinkButton(`vendas/negocios/${id}`)
                        break;
                }
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import 'styles.styl';
</style>